import styled from 'styled-components'

import FormikForm from '../../../form/FormikForm'
import FormSubmitButton from '../../../form/FormSubmitButton'
import FormFieldText from '../../../form/fields/FormFieldInput'
import FormErrors from '../../../form/FormErrors'
import Card from '../../../Card'
import breakpoints from '../../../../theme/breakpoints'
import Link from '../../../Link'
import ActionButton from '../../../ActionButton'

export const CardWrapper = styled(Card)``

export const LinkWrapper = styled.div`
  margin-right: auto;
`

export const Title = styled.h5`
  ${({ theme }) => theme.textStyles.H5};
  margin-bottom: 3.2rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.nightRider};
`

export const Form = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 3.2rem;
  align-items: center;
  margin-bottom: 1rem;
`

export const FieldText = styled(FormFieldText)`
  width: 100%;

  min-width: 25rem;

  ${breakpoints.up('tablet')} {
    min-width: 37rem;
  }
`

export const ForgotPassword = styled(Link)`
  ${({ theme }) => theme.textStyles.textMedium};
  color: ${({ theme }) => theme.colors.nightRider};
  text-decoration: underline;
  width: 100%;
  text-align: left;
`

export const Errors = styled(FormErrors)`
  margin-top: 1rem;
`

export const SubmitButton = styled(FormSubmitButton)`
  display: block;
  margin: 3.6rem auto 3.2rem auto;
`

export const TextDivider = styled.div`
  ${({ theme }) => theme.textStyles.textLarge};
  color: ${({ theme }) => theme.colors.nightRider};
  margin-bottom: 1.6rem;
`

export const SSO = styled(ActionButton)``
